export default "__VITE_ASSET__Y1iW9WnD__"